export default {"src":"/_next/static/media/NAB.b100bc4e.svg","height":425,"width":875};